<template>
  <div class="box">
    <div class="box_1">
      <div class="t1"></div>
      <div class="t2"></div>
      <div class="t3">
        <div
          class="download_2"
          @click="download($store.state.down_url)"
        ></div>
        <div
          class="sh_2"
          @click="download($store.state.down_url_server)"
        ></div>
        <div
          class="console-down"
          @click="download($store.state.down_url_console)"
        ></div>
      </div>
    </div>
    <div class="box_8">
      <div class="box_8_img"></div>
    </div>
    <div class="box_2">
      <div class="t1">了解一下这个玩家效率提升平台</div>
      <div class="nav_box">
        <div
          class="item"
          :class="{ nav_on: nav_index == 0, nav_off: nav_index != 0 }"
          @click="nav_index = 0"
        >
          快速搜索
        </div>
        <div class="shu"></div>
        <div
          class="item"
          :class="{ nav_on: nav_index == 1, nav_off: nav_index != 1 }"
          @click="nav_index = 1"
        >
          数据同步
        </div>
        <div class="shu"></div>
        <div
          class="item"
          :class="{ nav_on: nav_index == 2, nav_off: nav_index != 2 }"
          @click="nav_index = 2"
        >
          热游福利
        </div>
        <div class="shu"></div>
        <div
          class="item"
          :class="{ nav_on: nav_index == 3, nav_off: nav_index != 3 }"
          @click="nav_index = 3"
        >
          游戏特权
        </div>
        <div class="shu"></div>
        <div
          class="item"
          :class="{ nav_on: nav_index == 4, nav_off: nav_index != 4 }"
          @click="nav_index = 4"
        >
          启动托盘
        </div>
      </div>
      <div
        class="nav_bg"
        :class="{
          img_0: nav_index == 0,
          img_1: nav_index == 1,
          img_2: nav_index == 2,
          img_3: nav_index == 3,
          img_4: nav_index == 4,
        }"
      ></div>
    </div>
    <div class="box_3">
      <img src="~@/assets/images/box_3.png" />
    </div>
  </div>
</template>

<script>
// import { steamtest } from '@/service/api'

export default {
  components: {},
  data() {
    return {
      nav_index: 0,
      btn_in: 0,
    };
  },
  created() {},
  mounted() {
    // this.steamtestfun()
  },

  methods: {
    // async steamtestfun(){
    //   let p={
    //      key:'1E53356031440D0AB079C45A2823CF78',
    //      steamid:'76561198215853440',
    //      format:'JSON',
    //      include_appinfo:1,
    //      include_played_free_games:1
    //   }
    //   const res=await steamtest(p)
    //   console.log('测试steam接口')
    //   console.log(res)
    // },
    gosh() {
      window.open(this.$store.state.sh_url, "_blank");
    },
    download(url) {

      this.$confirm('安装ZZ助手后，请确认正在使用的去广告拦截软件是否加入白名单以避免出现功能冲突而导致的各类问题。', `郑重提示`, {
        confirmButtonText: '确认下载',
        cancelButtonText: '取消下载',
        center: true,
      }).then(() => {
        const fileUrl = url;
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "XXXX");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(() => {
      });
    },
  },
};
</script>
<style scoped lang="less">
.box {
  //   border: 1px solid red;
  width: 100%;
  height: 100%;
  //   background: #000;
  //   background: linear-gradient(to right, #fff,#aaa);
  display: flex;
  flex-direction: column;
  .box_1 {
    width: 100%;
    height: 708px;
    background: url(~@/assets/images/bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    .t1 {
      width: 436px;
      height: 158px;
      background: url(~@/assets/images/t1.png);
      background-size: contain;
      background-repeat: no-repeat;
      margin-left: 240px;
      margin-top: 194px;
    }
    .t2 {
      width: 436px;
      height: 48px;
      background: url(~@/assets/images/t2.png);
      background-size: cover;
      background-repeat: no-repeat;
      margin-left: 240px;
      margin-top: 44px;
    }
    .t3 {
      margin-top: 44px;
      margin-left: 240px;
      width: 600px;
      height: 52px;
      display: flex;
      .download_2 {
        width: 168px;
        height: 52px;
        // background-position: -30px 0;
        cursor: pointer;
        -webkit-box-reflect: below 2px
          linear-gradient(transparent, rgba(0, 0, 0, 0.2));
          background: url(~@/assets/images/d2_2.png);
          background-size: cover;
          background-repeat: no-repeat;
          &:hover {
            background: url(~@/assets/images/d2_1.png);
            background-size: cover;
            background-repeat: no-repeat;
          }
      }
      .sh_2 {
        width: 168px;
        height: 52px;
        // background-position: 198px 0;
        cursor: pointer;
        margin-left: 44px;
        -webkit-box-reflect: below 2px
          linear-gradient(transparent, rgba(0, 0, 0, 0.2));
        background: url(~@/assets/images/d3_2.png);
        background-size: cover;
        background-repeat: no-repeat;
        &:hover {
          background: url(~@/assets/images/d3_1.png);
          background-size: cover;
          background-repeat: no-repeat;
        }
      }
      .console-down {
        width: 168px;
        height: 52px;
        // background-position: 198px 0;
        cursor: pointer;
        margin-left: 44px;
        -webkit-box-reflect: below 2px
        linear-gradient(transparent, rgba(0, 0, 0, 0.2));
        background: url(~@/assets/images/console_2.png);
        background-size: cover;
        background-repeat: no-repeat;
        &:hover {
          background: url(~@/assets/images/console_1.png);
          background-size: cover;
          background-repeat: no-repeat;
        }
      }
    }
  }
  .box_2 {
    width: 100%;
    height: 800px;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    align-items: center;
    .t1 {
      font-size: 34px;
      color: #fff;
    }
    .nav_box {
      margin-top: 64px;
      width: 584px;
      height: 56px;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      background: #2c2c49;
      border-radius: 10px;
      .item {
        width: 98px;
        height: 39px;
        line-height: 39px;
        font-size: 18px;
        margin-left: 20px;
        cursor: pointer;
      }
      .nav_on {
        color: #949fff;
      }
      .nav_off {
        color: #fff;
      }
      .item:hover {
        color: #949fff;
      }
      .shu {
        margin-left: 8px;
        width: 1px;
        height: 10px;
        background: #666;
      }
    }
    .nav_bg {
      margin-top: 64px;
      width: 944px;
      height: 726px;
      // border: 1px solid red;
    }
    .img_0 {
      background: url(~@/assets/images/img0.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .img_1 {
      background: url(~@/assets/images/img1.png);
      background-size: cover;
      background-repeat: no-repeat;
    }
    .img_2 {
      background: url(~@/assets/images/img2.png);
      background-size: cover;
      background-repeat: no-repeat;
    }
    .img_3 {
      background: url(~@/assets/images/img3.png);
      background-size: cover;
      background-repeat: no-repeat;
    }
    .img_4 {
      background: url(~@/assets/images/img4.png);
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  .box_3 {
    width: 100%;
    // height: 703px;
    // background: url(~@/assets/images/box_3.png);
    background-size: cover;
    background-repeat: no-repeat;
    img {
      width: 100%;
      height: auto;
    }
  }
  .box_8 {
    width: 100%;
    height: 1633px;
    .box_8_img {
      width: 1440px;
      height: 100%;
      margin: auto;
      background: url(~@/assets/images/box_8.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>
